import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { AbilityService } from '@common/services/auth';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private readonly ability = inject(AbilityService);
  private readonly title = inject(Title);

  protected readonly isGoogle = this.ability.isGoogle;
  protected readonly isOffice = this.ability.isOffice;

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot) || 'Apps';

    if (this.isOffice()) {
      return this.title.setTitle(`${pageTitle} - Microsoft 365 Business backup`);
    }

    if (this.isGoogle()) {
      return this.title.setTitle(`${pageTitle} - Google Workspace backup`);
    }

    this.title.setTitle(pageTitle);
  }
}
